export interface ModelConfig {
	file: File | null,
}

const dataset: ModelConfig = {   
	file: null
}

export default dataset